import { useState, useCallback } from 'react';
import { ELECTION_TYPE, NOMINATION_STATUS } from '../../utils/constants';

export const useShortlistHandlers = (showNotification) => {
  // Stage 1 shortlist state
  const [showModal, setShowModal] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [selectedNominationId, setSelectedNominationId] = useState(null);

  // Stage 2 (Council) shortlist state
  const [showStage2Modal, setShowStage2Modal] = useState(false);
  const [selectedStage2Candidate, setSelectedStage2Candidate] = useState(null);
  const [selectedStage2NominationId, setSelectedStage2NominationId] =
    useState(null);

  // Shortlist
  const handleSelectClick = useCallback((nominationId, candidate) => {
    setSelectedCandidate(candidate);
    setSelectedNominationId(nominationId);
    setShowModal(true);
  }, []);

  const handleCancelSelect = useCallback(() => {
    setShowModal(false);
    setSelectedCandidate(null);
    setSelectedNominationId(null);
  }, []);

  // Recommend to council
  const handleStage2SelectClick = useCallback(
    (nominationId, candidate, committeeId, nominationArray) => {
      const MAX_COUNCIL_RECOMMENDATIONS = 4;

      const getCommitteeId = (nom) => {
        if (nom.attributes.electionTypeId === ELECTION_TYPE.SPECIAL_ELECTION)
          return 15;
        if (
          nom.attributes.electionTypeId === ELECTION_TYPE.CORRESPONDING_MEMBER
        )
          return 14;
        return nom.attributes.sectionalCommitteeId;
      };

      const stage2Count =
        nominationArray?.filter(
          (nom) =>
            nom.attributes.nominationStatusTypeId ===
              NOMINATION_STATUS.RECOMMENDED &&
            getCommitteeId(nom) === committeeId,
        ).length || 0;

      if (stage2Count >= MAX_COUNCIL_RECOMMENDATIONS) {
        showNotification(
          'Council Recommendation Limit Reached',
          `You have already recommended the maximum of ${MAX_COUNCIL_RECOMMENDATIONS} candidates to Council for this committee. To recommend ${candidate}, please first remove one of your existing recommendations.`,
          'fa-exclamation-triangle',
          'text-warning',
        );
        return;
      }

      setSelectedStage2Candidate(candidate);
      setSelectedStage2NominationId(nominationId);
      setShowStage2Modal(true);
    },
    [showNotification],
  );

  const handleCancelStage2Select = useCallback(() => {
    setShowStage2Modal(false);
    setSelectedStage2Candidate(null);
    setSelectedStage2NominationId(null);
  }, []);

  // Ranking
  const handleRankingSuccess = useCallback(
    (candidateName, rank) => {
      if (rank === null) {
        showNotification(
          'Ranking Removed',
          `Ranking has been removed from ${candidateName}.`,
          'bi-trophy-fill',
          'text-ranked ranked-icon-bg-color',
        );
      } else {
        showNotification(
          `Rank ${rank}`,
          `${candidateName} has been ranked at position ${rank}.`,
          'bi-trophy-fill',
          'text-ranked ranked-icon-bg-color',
        );
      }
    },
    [showNotification],
  );

  return {
    // Shortlist
    showModal,
    setShowModal,
    selectedCandidate,
    setSelectedCandidate,
    selectedNominationId,

    // Recommend to council
    showStage2Modal,
    setShowStage2Modal,
    selectedStage2Candidate,
    setSelectedStage2Candidate,
    selectedStage2NominationId,

    // Handlers
    handleSelectClick,
    handleStage2SelectClick,
    handleCancelSelect,
    handleCancelStage2Select,
    handleRankingSuccess,
  };
};
